import React from 'react';
import { view } from '@risingstack/react-easy-state';

import './HeaderBar.scss';

export default view((props) => (
  <div className="headerBar">
    {props.children}
  </div>
));